import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useVendorAuth } from '../../context/VendorAuthContext';

const AutoLogin = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { login } = useVendorAuth();
    const [isProcessing, setIsProcessing] = React.useState(false);

    useEffect(() => {
        if (isProcessing) return;

        const queryParams = new URLSearchParams(location.search);
        const token = queryParams.get('token');

        if (token) {
            setIsProcessing(true);
            try {
                // simple jwt parsing to get payload
                const base64Url = token.split('.')[1];
                const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));

                const decodedUser = JSON.parse(jsonPayload);

                const userInfo = {
                    id: decodedUser.userId,
                    name: decodedUser.userName,
                    email: decodedUser.email,
                    role_id: decodedUser.roleId,
                    phone: decodedUser.phone,
                    is_verified: true,
                    last_registration_step: Number(decodedUser.last_registration_step ?? 0),
                    is_impersonated: Boolean(decodedUser.is_impersonated)
                };

                // Clear previous session data completely to avoid cross-vendor session leaks
                const keysToClear = ['userSessionData', 'authToken', 'token', 'userInfo'];
                keysToClear.forEach(key => {
                    localStorage.removeItem(key);
                    sessionStorage.removeItem(key);
                });

                // Call login from VendorAuthContext to update state, fetch latest details and navigate
                login(token, userInfo);
                
            } catch (error) {
                console.error("Invalid token:", error);
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }, [location, navigate, login, isProcessing]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#f0f2f5' }}>
            <div style={{ textAlign: 'center' }}>
                <i className="fas fa-spinner fa-spin" style={{ fontSize: '3rem', color: '#007bff' }}></i>
                <h4 className="mt-3" style={{fontFamily: 'Poppins, sans-serif'}}>Logging you in securely...</h4>
            </div>
        </div>
    );
};

export default AutoLogin;
